// extracted by mini-css-extract-plugin
export default {"content":"content__zJ3PsEJl","card":"card__LKpBavby","header":"header__c4Cew_Sc","body":"body__xi6Z65cR","footer":"footer__Cz9b0QEg","securedByWrapper":"securedByWrapper__Xtdy2y62"};